import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import ReactPaginate from "react-paginate";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";
import { isoToDateTime, priceFormat } from "../../inc/helper";

import Select from 'react-select';

function formatPlate(plate) {
  const match = plate.match(/^(\d{2})([A-ZÇĞİÖŞÜ]{1,3})(\d{2,5})$/i);
  if (!match) return plate;
  return `${match[1]} ${match[2].toUpperCase()} ${match[3]}`;
}

class AuctionItemsModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

      auctionItems: [],
      vehicleBrands: [],
      vehicleModels: [],
      vehicleModelYears: [],
      vehicleEquipments: [],

      filterId: '',
      filterAuctionVehicleId: '',
      filterVehicleBrandId: '',
      filterVehicleModelId: '',
      filterVehicleYear: '',
      filterVehicleEquipmentId: '',
      filterMinInitialPrice: '',
      filterMaxInitialPrice: '',
      filterMinThresholdPrice: '',
      filterMaxThresholdPrice: '',
      filterAddedBy: '',
      filterStartStartDate: '',
      filterEndStartDate: '',


      pageCount: 0,
      resultCount: 0,
      currentPage: 1,
      limit: 10,
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(searchParams.get("page")) || 1;
  
    this.setState({
      currentPage,
      filterId: searchParams.get("filterId") || '',
      filterAuctionVehicleId: searchParams.get("filterAuctionVehicleId") || '',
      filterVehicleBrandId: searchParams.get("filterVehicleBrandId") || '',
      filterVehicleModelId: searchParams.get("filterVehicleModelId") || '',
      filterVehicleYear: searchParams.get("filterVehicleYear") || '',
      filterVehicleEquipmentId: searchParams.get("filterVehicleEquipmentId") || '',
      filterMinInitialPrice: searchParams.get("filterMinInitialPrice") || '',
      filterMaxInitialPrice: searchParams.get("filterMaxInitialPrice") || '',
      filterMinThresholdPrice: searchParams.get("filterMinThresholdPrice") || '',
      filterMaxThresholdPrice: searchParams.get("filterMaxThresholdPrice") || '',
      filterAddedBy: searchParams.get("filterAddedBy") || '',
      filterStartStartDate: searchParams.get("filterStartStartDate") || '',
      filterEndStartDate: searchParams.get("filterEndStartDate") || '',
    }, () => {
      this.getAuctions(this.state.currentPage);
      if (!this.props.searchParams.get('filterVehicleBrandId')) {
        this.getAuctionVehicleBrands();
      } else{
        this.getBrand();
      }
    });
    window.scrollTo(0, 0);
  }
  
  getBrand() {
    let sessionHash = getCookie('sessionHash');
    this.setState({ isLoading: true });
  
    const requestOptions = {
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + sessionHash }
    };
  
    let errorMessages = [];

    // Marka listesi çekiliyor
    fetch(config.restApi + 'vehicleBrands/tr?limit=1000', requestOptions)
      .then(res => res.json())
      .then(brandData => {
        if (brandData.status === 200) {
          this.setState({ vehicleBrands: brandData.vehicleBrands });
        } else {
          errorMessages.push(brandData.message);
        }

        if (this.props.searchParams.get('filterVehicleBrandId')) {
          // Model listesi çekiliyor
          fetch(config.restApi + 'vehicleModels/tr/' + this.props.searchParams.get('filterVehicleBrandId') + '?limit=1000', requestOptions)
          .then(res => res.json())
          .then(modelData => {
            if (modelData.status === 200) {
              this.setState({
                vehicleModels: modelData.vehicleModels
              });
            } else {
              errorMessages.push(modelData.message);
            }

            if (this.props.searchParams.get('filterVehicleModelId')) {
              // Model listesi çekiliyor
              fetch(config.restApi + 'vehicleModelYears/tr/' + this.props.searchParams.get('filterVehicleModelId') + '?limit=1000', requestOptions)
              .then(res => res.json())
              .then(modelData => {
                if (modelData.status === 200) {
                  this.setState({
                    vehicleModelYears: modelData.vehicleModelYears
                  });
                } else {
                  errorMessages.push(modelData.message);
                }

                if (this.props.searchParams.get('filterVehicleYear')) {
                  // Variant listesi çekiliyor
                  fetch(config.restApi + 'vehicleEquipments/tr/' + this.props.searchParams.get('filterVehicleModelId') + '/' + this.props.searchParams.get('filterVehicleYear') + '?limit=1000', requestOptions)
                  .then(res => res.json())
                  .then(variantData => {
                    if (variantData.status === 200) {
                      this.setState({
                        vehicleEquipments: variantData.vehicleEquipments
                      });
                    } else {
                      errorMessages.push(variantData.message);
                    }

                    // Tüm işlemler tamamlandı
                    this.setState({ isLoading: false });
                    if (errorMessages.length > 0) {
                      swal({
                        dangerMode: true,
                        icon: 'warning',
                        title: 'Hay Aksi',
                        text: errorMessages[0],
                        buttons: 'Tamam'
                      }).then(() => this.props.navigate('/home'));
                    }
                  }).catch(() => {
                    errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.');
                    this.setState({ isLoading: false });
                  });
                }
                }).catch(() => {
                errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.');
                this.setState({ isLoading: false });
              }); 
            }
          }).catch(() => {
            errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.');
            this.setState({ isLoading: false });
          }); 
        }
      }).catch(() => {
        errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.');
        this.setState({ isLoading: false });
      });
  
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  getAuctions(currentPage) {
    const { filterId, filterAuctionVehicleId, limit, filterVehicleBrandId, filterVehicleYear, filterVehicleModelId, filterVehicleEquipmentId, filterMinInitialPrice, filterMaxInitialPrice, filterMinThresholdPrice, filterMaxThresholdPrice, filterAddedBy, filterStartStartDate, filterEndStartDate } = this.state;
    let sessionHash = getCookie("sessionHash");

    const requestOptions = {
      method: "GET",
      headers: { Authorization: "Bearer " + sessionHash },
    };

    let query = `limit=${limit}&page=${currentPage}`;
    if (filterId) query += `&filterId=${filterId}`;
    if (filterAuctionVehicleId) query += `&filterAuctionVehicleId=${filterAuctionVehicleId}`;
    if (filterVehicleBrandId) query += `&filterVehicleBrandId=${filterVehicleBrandId}`;
    if (filterVehicleModelId) query += `&filterVehicleModelId=${filterVehicleModelId}`;
    if (filterVehicleYear) query += `&filterVehicleYear=${filterVehicleYear}`;
    if (filterVehicleEquipmentId) query += `&filterVehicleEquipmentId=${filterVehicleEquipmentId}`;
    if (filterMinInitialPrice) query += `&filterMinInitialPrice=${filterMinInitialPrice}`;
    if (filterMaxInitialPrice) query += `&filterMaxInitialPrice=${filterMaxInitialPrice}`;
    if (filterMinThresholdPrice) query += `&filterMinThresholdPrice=${filterMinThresholdPrice}`;
    if (filterMaxThresholdPrice) query += `&filterMaxThresholdPrice=${filterMaxThresholdPrice}`;
    if (filterAddedBy) query += `&filterAddedBy=${filterAddedBy}`;
    if (filterStartStartDate) query += `&filterStartStartDate=${filterStartStartDate}`;
    if (filterEndStartDate) query += `&filterEndStartDate=${filterEndStartDate}`;

    fetch(config.restApi + `auctionItems/tr/${this.props.searchParams.get('auctionId')}?${query}`, requestOptions)
      .then((response) => response.json())
      .then(
        (responseData) => {
          switch (responseData.status) {
            case 200:
              this.setState({isLoading: false, auctionItems: responseData.auctionItems, pageCount: responseData.pageCount, resultCount: responseData.resultCount, currentPage: currentPage});
            break;
            case 401:
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              }).then(this.props.navigate('/home'))
            break;
            default:
              swal({
                dangerMode: true,
                icon: "warning",
                title: "Hay Aksi",
                text: responseData.message,
                buttons: "Tamam",
              });
              break;
          }
        },
        () =>
          swal({
            dangerMode: true,
            icon: "error",
            title: "Bağlantı Hatası",
            text: "Lütfen internet bağlantınızı kontrol ediniz.",
            buttons: "Tamam",
          })
      );
  }

  getAuctionVehicleBrands() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleBrands/tr?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200:
          this.setState({isLoading: false, vehicleBrands: responseData.vehicleBrands})
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/expertises'))
        break;
        default:
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        break;
      }
    }, () =>swal({ dangerMode: true, icon: "error", title: "Bağlantı Hatası", text: "Lütfen internet bağlantınızı kontrol ediniz.", buttons: "Yeniden Dene",}).then(() => this.getMyAppointmentsDetail()));
  }

  getModels(vehicleBrandId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleModels/tr/' + vehicleBrandId + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleBrandId: vehicleBrandId, vehicleModelId: '', vehicleModels: responseData.vehicleModels});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getYears(vehicleModelId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleModelYears/tr/' + vehicleModelId + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleModelId: vehicleModelId, vehicleModelYears: responseData.vehicleModelYears});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }
  
  getVehicleEquipments(vehicleModelId, year) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleEquipments/tr/' + vehicleModelId + '/' + year + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleModelId: vehicleModelId, vehicleEquipments: responseData.vehicleEquipments});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  deleteAuctionItemOnClick(id) {
    swal({
      dangerMode: true,
      icon: 'warning',
      title: 'Onayla',
      text: 'Aracı ihaleden kaldırmak istediğinize emin misiniz?',
      buttons: {confirm: 'Tamam', cancel: 'Vazgeç'}
    }).then(value => {
      if (value) {
        let sessionHash = getCookie('sessionHash');

        const requestOptions = {
          method: 'DELETE',
          headers: {'Authorization': 'Bearer ' + sessionHash}
        };

        fetch(config.restApi + 'auctionItem/tr/' + id, requestOptions)
        .then(response => response.json())
        .then(responseData => {
          switch (responseData.status) {
            case 200: {
              swal({
                dangerMode: true,
                icon: 'success',
                title: 'Tamamlandı',
                text: 'Araç ihaleden başarıyla kaldırıldı.',
                buttons: 'Tamam'
              }).then(() => this.getAuctions());
            }
            break;
            default: {
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              });
            }
            break;
          }
        }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
      }
    });
  }

  handlePageClick(page) {
    // URL parametrelerini güncellemek için URLSearchParams kullanıyoruz
    const params = new URLSearchParams(window.location.search);
  
    // Mevcut sayfa parametresini güncelliyoruz
    params.set('page', page.selected + 1);  // sayfa numarası 0-indexed olduğu için +1 ekliyoruz
  
    // Yeni URL'yi oluşturuyoruz
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    
    // URL'yi güncelliyoruz (browser history'yi de değiştiriyoruz, sayfa yenilenmeden)
    window.history.pushState(null, '', newUrl);
    
    this.setState({ currentPage: page.selected + 1 }, () => {this.getAuctions(this.state.currentPage);});
  }

  filterOnClick = () => {
    const params = new URLSearchParams();
    params.append('auctionId', this.props.searchParams.get('auctionId'));
  
    if (this.state.currentPage) params.append('page', 1);
    if (this.state.filterAuctionVehicleId) params.append('filterAuctionVehicleId', this.state.filterAuctionVehicleId);
    if (this.state.filterVehicleBrandId) params.append('filterVehicleBrandId', this.state.filterVehicleBrandId);
    if (this.state.filterVehicleModelId) params.append('filterVehicleModelId', this.state.filterVehicleModelId);
    if (this.state.filterVehicleYear) params.append('filterVehicleYear', this.state.filterVehicleYear);
    if (this.state.filterVehicleEquipmentId) params.append('filterVehicleEquipmentId', this.state.filterVehicleEquipmentId);
    if (this.state.filterMinInitialPrice) params.append('filterMinInitialPrice', this.state.filterMinInitialPrice);
    if (this.state.filterMaxInitialPrice) params.append('filterMaxInitialPrice', this.state.filterMaxInitialPrice);
    if (this.state.filterMinThresholdPrice) params.append('filterMinThresholdPrice', this.state.filterMinThresholdPrice);
    if (this.state.filterMaxThresholdPrice) params.append('filterMaxThresholdPrice', this.state.filterMaxThresholdPrice);
    if (this.state.filterAddedBy) params.append('filterAddedBy', this.state.filterAddedBy);
    if (this.state.filterStartStartDate) params.append('filterStartStartDate', this.state.filterStartStartDate);
    if (this.state.filterEndStartDate) params.append('filterEndStartDate', this.state.filterEndStartDate);
  
    const queryString = params.toString();
    this.props.navigate(`?${queryString}`);
  
    this.getAuctions(1); // Sayfa 1'den başla
  };

  resetOnClick = () => {
    this.setState({
      filterId: '',
      filterAuctionVehicleId: '',
      filterVehicleBrandId: '',
      filterVehicleModelId: '',
      filterVehicleYear: '',
      filterVehicleEquipmentId: '',
      filterMinInitialPrice: '',
      filterMaxInitialPrice: '',
      filterMinThresholdPrice: '',
      filterMaxThresholdPrice: '',
      filterAddedBy: '',
      filterStartStartDate: '',
      filterEndStartDate: '',
      vehicleModels: [],
      vehicleEquipments: [],
      vehicleModelYears: []
    }, () => {
      const auctionId = this.props.searchParams.get('auctionId');
      const params = new URLSearchParams();
  
      if (auctionId) {
        params.append('auctionId', auctionId);
      }
  
      this.props.navigate(`?${params.toString()}`); // sadece auctionId kalsın
      this.getAuctions(1); // Sayfa 1'den başla
    });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.filterOnClick();
    }
  };

  selectedBrandOnChange = (selectedBrand) => {
    const vehicleBrandId = selectedBrand ? selectedBrand.value : '';
    if (vehicleBrandId) {
      this.getModels(vehicleBrandId);
    } else {
      this.setState({ filterVehicleBrandId: '', filterVehicleYear: '', filterVehicleModelId: '', filterVehicleEquipmentId: '', vehicleModels: [], vehicleModelYears: [], vehicleEquipments: [] });
      return;
    }
  
    this.setState({ filterVehicleBrandId: vehicleBrandId, filterVehicleModelId: '', filterVehicleYear: '', filterVehicleEquipmentId: '', vehicleModelYears: [], vehicleEquipments: [] });
  };

  selectedYearOnChange = (selectedYear) => {

    const year = selectedYear ? selectedYear.search : ''

    if (year) {
      this.getVehicleEquipments(this.state.filterVehicleModelId, year);
    } else {
      this.setState({ filterVehicleYear: '', filterVehicleEquipmentId: '', vehicleEquipments: [] });
      return;
    }

    this.setState({ filterVehicleYear: parseInt(year), filterVehicleEquipmentId: '', vehicleEquipments: [] });
  }
  
  selectedModelOnChange = (selectedModel) => {
    const vehicleModelId = selectedModel ? selectedModel.value : '';

    if (vehicleModelId) {
      this.getYears(vehicleModelId);
    } else {
      this.setState({ filterVehicleModelId: '', filterVehicleYear: '', filterVehicleEquipmentId: '', vehicleModelYears: [], vehicleEquipments: [] });
      return;
    }

    this.setState({ filterVehicleModelId: vehicleModelId, filterVehicleYear: '', filterVehicleEquipmentId: '', vehicleEquipments: [] });
  };

  selectedVariantOnChange = (selectedVariant) => {
    const equipmentId = selectedVariant ? selectedVariant.value : '';
    this.setState({ filterVehicleEquipmentId: equipmentId });
  };

  render() {

    const selectedBrandsOptions = [
      {value: '', label: 'Seçiniz' }, ...this.state.vehicleBrands.map((brandInfo) => ({
        value: brandInfo.id,
        label: `${brandInfo.name}`,
        search: brandInfo.name
      }))
    ];

    const selectedModelsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleModels.map((modelInfo) => ({
        value: modelInfo.id,
        label: `${modelInfo.name}`,
        search: modelInfo.name
      }))
    ];

    const selectedYearsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleModelYears.map((yearInfo) => ({
        value: yearInfo.year,
        label: `${yearInfo.year}`,
        search: yearInfo.year
      }))
    ];

    const selectedVariantsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleEquipments.map((variantInfo) => ({
        value: variantInfo.id,
        label: `${variantInfo.name}`,
        search: variantInfo.name
      }))
    ];

    return this.state.isLoading ? (
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
    ) : (
      <div className="row custom-container">
        <div className="col-xl-9">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between pr-3">
              <strong className="text-black">İhale Araçları</strong>
              <div className="d-flex">
                <Link className="btn btn-orange mr-1" title="İhale Aracı Ekle" to={`/auctionItemChoose?auctionId=${this.props.searchParams.get('auctionId')}`}><i className="fa fa-plus"></i></Link>
                <Link className="btn btn-darkblue text-white" title="Geri" to={"/auctions"}> <i className="fa fa-reply"></i></Link>
              </div>
            </div>
            <div className="table-responsive-lg mb-5">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="text-black">
                    <th>Araç Adı</th>
                    <th>Marka</th>
                    <th>Konum</th>
                    <th>Açılış Fiyatı</th>
                    <th>Eşik Fiyatı</th>
                    <th>Başlangıç Tarihi</th>
                    <th>Bitiş Tarihi</th>
                    <th>Detay</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.auctionItems.map((auctionItem, index) =>
                    <tr key={index}>
                      <td className="align-middle">{auctionItem.title}<br />Araç No #:<b>{auctionItem.auctionVehicleId}</b></td>
                      <td className="align-middle">Plaka:<br /><b>{formatPlate(auctionItem.auctionVehicleDetails?.plateNumber)}</b> <br /><br /> {auctionItem.auctionVehicleBrandName} - {auctionItem.auctionVehicleModelName} {auctionItem.auctionVehicleYear > 0 && "- " + auctionItem.auctionVehicleYear} <br /> {auctionItem.auctionVehicleEquipmentName}</td>
                      <td className="align-middle">{auctionItem.cityName} / {auctionItem.townName}</td>
                      <td className="align-middle">{priceFormat(auctionItem.initialPrice)} ₺</td>
                      <td className="align-middle">{priceFormat(auctionItem.thresholdPrice)} ₺</td>
                      <td className="align-middle">{isoToDateTime(auctionItem.startDate)}</td>
                      <td className="align-middle">{isoToDateTime(auctionItem.endDate)}</td>
                      <td className="align-middle" style={{minWidth:98.5}}>
                        <Link className="btn btn-orange m-1" title="Düzenle" to={`/auctionItemEdit?id=${auctionItem.id}`}><i className="fa fa-pencil"></i></Link>
                        <button className="btn btn-orange m-1" title="Sil" onClick={() => this.deleteAuctionItemOnClick(auctionItem.id)}><i className="fa fa-trash"></i></button>
                        <Link className="btn btn-darkblue m-1" title="İhale Araç Detayı" to={`/auctionItemDetail?id=${auctionItem.id}`}><i className="fa fa-eye"></i></Link>
                        <Link className="btn btn-darkblue" title="Teklifler" to={`/auctionMemberOffers?auctionItemId=${auctionItem.id}&auctionVehicleId=${auctionItem.auctionVehicleId}`}><i className="fa fa-money"></i></Link>
                      </td>
                    </tr>
                  )}
                  {this.state.auctionItems.length === 0 && <tr><td className="align-middle text-darkblue p-3" colSpan="8">İhale Bulunamadı !</td></tr>}
                </tbody>
              </table>
            </div>
            {this.state.auctionItems.length !== 0 &&
            <ReactPaginate
              previousLabel={"Geri"}
              nextLabel={"İleri"}
              breakLabel={"..."}  
              pageCount={this.state.pageCount}
              marginPagesDisplayed={1}
              onPageChange={page => this.handlePageClick(page)}
              pageRangeDisplayed={2}
              containerClassName={'pagination'}
              activeClassName={'activePage'}
              forcePage={Number(this.state.currentPage) - 1}
            />
            }
          </div>
        </div>
        <div className="col-xl-3 order-first order-xl-last d-xl-none" id="accordion">
          <div className="ibox">
            <div className="ibox-content text-darkblue p-0">
              <h4 className="collapse-title">
                <a className="btn btn-link text-darkblue font-bold d-flex justify-content-between" data-toggle="collapse" href="#filterCollapse" title="Filtrele">Filtrele</a>
              </h4>
            </div>
            <div className="collapse" data-parent="#accordion" id="filterCollapse">
              <div className="ibox-content text-darkblue">  
                <strong>Araç No</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterAuctionVehicleId: event.target.value.replace(/\D+/g, '')})} onKeyDown={this.handleKeyPress} placeholder="Araç No" type="text" value={this.state.filterAuctionVehicleId}/>
                <strong>Marka</strong>
                <Select
                  className="form-input mb-2 mt-1 text-dark"
                  onChange={this.selectedBrandOnChange}
                  options={selectedBrandsOptions}
                  isClearable={true}
                  defaultValue={selectedBrandsOptions.find((brand) => brand.value.toString() === this.state.filterVehicleBrandId) || selectedBrandsOptions[0]}
                  placeholder="Seçiniz"
                  value={selectedBrandsOptions.find((brand) => brand.value.toString() === this.state.filterVehicleBrandId)}
                  filterOption={(option, searchText) =>
                    option.data.search &&
                    option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                  }
                />
                <strong>Model</strong>
                <Select
                  className="form-input mb-2 mt-1 text-dark"
                  isDisabled={this.state.vehicleModels.length === 0}
                  onChange={this.selectedModelOnChange}
                  options={selectedModelsOptions}
                  isClearable={true}
                  defaultValue={selectedModelsOptions.find((model) => model.value.toString() === this.state.filterVehicleModelId) || selectedModelsOptions[0]}
                  placeholder="Seçiniz"
                  value={selectedModelsOptions.find((model) => model.value.toString() === this.state.filterVehicleModelId)}
                  filterOption={(option, searchText) =>
                    option.data.search &&
                    option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                  }
                />
                <h5><strong>Araç Yılı<strong className="text-danger ml-1">*</strong></strong></h5>
                <Select
                  className="form-input mb-2 mt-1 text-dark"
                  isDisabled={this.state.vehicleModelYears.length === 0}
                  onChange={this.selectedYearOnChange}
                  options={selectedYearsOptions}
                  isClearable={true}
                  defaultValue={selectedYearsOptions.find((year) => year.value == this.state.filterVehicleYear) || selectedYearsOptions[0]}
                  placeholder="Seçiniz"
                  value={selectedYearsOptions.find((year) => year.value == this.state.filterVehicleYear)}
                  /* filterOption={(option, searchText) =>
                    option.data.search &&
                    option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                  } */
                />
                <strong>Donanım</strong>
                <Select
                  className="form-input mb-2 mt-1 text-dark"
                  isDisabled={this.state.vehicleEquipments.length === 0}
                  onChange={this.selectedVariantOnChange}
                  options={selectedVariantsOptions}
                  isClearable={true}
                  defaultValue={selectedVariantsOptions.find((variant) => variant.value.toString() == this.state.filterVehicleEquipmentId) || selectedVariantsOptions[0]}
                  placeholder="Seçiniz"
                  value={selectedVariantsOptions.find((variant) => variant.value.toString() == this.state.filterVehicleEquipmentId)}
                  filterOption={(option, searchText) =>
                    option.data.search &&
                    option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                  }
                />
                <strong>Min Açılış Fiyatı</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMinInitialPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Min Açılış Fiyatı" type="text" value={this.state.filterMinInitialPrice}/>
                <strong>Max Açılış Fiyatı</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMaxInitialPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Max Açılış Fiyatı" type="text" value={this.state.filterMaxInitialPrice}/>
                <strong>Min Eşik Fiyatı</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMinThresholdPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Min Eşik Fiyatı" type="text" value={this.state.filterMinThresholdPrice}/>
                <strong>Max Eşik Fiyatı</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMaxThresholdPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Max Eşik Fiyatı" type="text" value={this.state.filterMaxThresholdPrice}/>
                <strong>Ekleyen</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterAddedBy: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Ekleyen" type="text" value={this.state.filterAddedBy}/>
                <strong>Başlangıç Tarihi</strong>
                <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({filterStartStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterStartStartDate}/>
                <strong>Bitiş Tarihi</strong>
                <input className="form-control form-input" onChange={event => this.setState({filterEndStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterEndStartDate} />
                <div className="d-flex justify-content-end">
                  <button className="btn btn-orange mt-3 mr-2" onClick={this.resetOnClick}><i className="fa fa-refresh"></i> Sıfırla</button>
                  <button className="btn btn-orange mt-3" onClick={this.filterOnClick}><i className="fa fa-filter"></i> Filtrele</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 order-first order-xl-last d-none d-xl-block">
          <div className="ibox">
            <div className="ibox-title text-darkblue">
              <h5><i className="fa fa-filter"></i> Filtrele</h5>
            </div>
            <div className="ibox-content text-darkblue">
              <strong>Araç No</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterAuctionVehicleId: event.target.value.replace(/\D+/g, '')})} onKeyDown={this.handleKeyPress} placeholder="Araç No" type="text" value={this.state.filterAuctionVehicleId}/>
              <strong>Marka</strong>
              <Select
                className="form-input mb-2 mt-1 text-dark"
                onChange={this.selectedBrandOnChange}
                options={selectedBrandsOptions}
                isClearable={true}
                defaultValue={selectedBrandsOptions.find((brand) => brand.value.toString() === this.state.filterVehicleBrandId) || selectedBrandsOptions[0]}
                placeholder="Seçiniz"
                value={selectedBrandsOptions.find((brand) => brand.value.toString() === this.state.filterVehicleBrandId)}
                filterOption={(option, searchText) =>
                  option.data.search &&
                  option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                }
              />
              <strong>Model</strong>
              <Select
                className="form-input mb-2 mt-1 text-dark"
                isDisabled={this.state.vehicleModels.length === 0}
                onChange={this.selectedModelOnChange}
                options={selectedModelsOptions}
                isClearable={true}
                defaultValue={selectedModelsOptions.find((model) => model.value.toString() === this.state.filterVehicleModelId) || selectedModelsOptions[0]}
                placeholder="Seçiniz"
                value={selectedModelsOptions.find((model) => model.value.toString() === this.state.filterVehicleModelId)}
                filterOption={(option, searchText) =>
                  option.data.search &&
                  option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                }
              />
              <h5><strong>Araç Yılı<strong className="text-danger ml-1">*</strong></strong></h5>
              <Select
                className="form-input mb-2 mt-1 text-dark"
                isDisabled={this.state.vehicleModelYears.length === 0}
                onChange={this.selectedYearOnChange}
                options={selectedYearsOptions}
                isClearable={true}
                defaultValue={selectedYearsOptions.find((year) => year.value == this.state.filterVehicleYear) || selectedYearsOptions[0]}
                placeholder="Seçiniz"
                value={selectedYearsOptions.find((year) => year.value == this.state.filterVehicleYear)}
                /* filterOption={(option, searchText) =>
                  option.data.search &&
                  option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                } */
              />
              <strong>Donanım</strong>
              <Select
                className="form-input mb-2 mt-1 text-dark"
                isDisabled={this.state.vehicleEquipments.length === 0}
                onChange={this.selectedVariantOnChange}
                options={selectedVariantsOptions}
                isClearable={true}
                defaultValue={selectedVariantsOptions.find((variant) => variant.value.toString() == this.state.filterVehicleEquipmentId) || selectedVariantsOptions[0]}
                placeholder="Seçiniz"
                value={selectedVariantsOptions.find((variant) => variant.value.toString() == this.state.filterVehicleEquipmentId)}
                filterOption={(option, searchText) =>
                  option.data.search &&
                  option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                }
              />
              <strong>Min Açılış Fiyatı</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMinInitialPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Min Açılış Fiyatı" type="text" value={this.state.filterMinInitialPrice}/>
              <strong>Max Açılış Fiyatı</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMaxInitialPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Max Açılış Fiyatı" type="text" value={this.state.filterMaxInitialPrice}/>
              <strong>Min Eşik Fiyatı</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMinThresholdPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Min Eşik Fiyatı" type="text" value={this.state.filterMinThresholdPrice}/>
              <strong>Max Eşik Fiyatı</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterMaxThresholdPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Max Eşik Fiyatı" type="text" value={this.state.filterMaxThresholdPrice}/>
              <strong>Ekleyen</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterAddedBy: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Ekleyen" type="text" value={this.state.filterAddedBy}/>
              <strong>Başlangıç Tarihi</strong>
              <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({filterStartStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterStartStartDate}/>
              <strong>Bitiş Tarihi</strong>
              <input className="form-control form-input" onChange={event => this.setState({filterEndStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterEndStartDate} />
              <div className="d-flex justify-content-end">
                <button className="btn btn-orange mt-3 mr-2" onClick={this.resetOnClick}><i className="fa fa-refresh"></i> Sıfırla</button>
                <button className="btn btn-orange mt-3" onClick={this.filterOnClick}><i className="fa fa-filter"></i> Filtrele</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default function AuctionItems(props) {
  return (
    <AuctionItemsModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionItemsModule>
  );
}
